import { Tier } from "../tier/tier.type";
import { RouteBase } from "./route-base.model";
import { ContainerPrices } from "../shared/container/container-prices.model";

export class FclRoute extends RouteBase {
  constructor(
    protected id: number,
    protected discriminator: string,
    protected comment: string,
    protected tier: Tier,
    protected containers: ContainerPrices = new ContainerPrices([]),
  ) {
    super(id, discriminator, comment);
  }

  public getContainers(): ContainerPrices {
    return this.containers;
  }
  public getTier(): Tier {
    return this.tier;
  }
  public setTier(tier: Tier) {
    this.tier = tier;
  }
}
